const auth_status = {
    page_title: '认证状态',
    title: '认证状态',
    description: '检查认证状态。',
};
export default Object.freeze(auth_status);
